import state from "../../data/stateActive.json";
import { useNavigate } from "react-router-dom";
import {
  ButtonSearchComponent,
  FilterComponent,
  InputSearchComponent,
} from "../../components";

export const CollectionSearchContainer = () => {
  const navigate = useNavigate();
  const filter = () => {
    const state = document.getElementById("stateCollection").value;
    const search = document.getElementById("searchCollection").value;

    let url = `/productos/colecciones?`;
    if (state !== "null") {
      url = url.concat(`active=${state}`);
    }
    if (search !== "null") {
      url = url.concat(`&search=${search}`);
    }
    navigate(url);
  };

  const handleEnter = (e) => {
    if (e.key !== "Enter") return;
    filter();
  };

  const dataInput = { id: "searchCollection", placeholder: "Buscar Colección" };
  return (
    <div className="collectionSearchContainer">
      <div className="collectionSearchContainer__filters">
        <div className="collectionSearchContainer__filters__item">
          <FilterComponent
            data={state}
            name={"Estado"}
            id={"stateCollection"}
          />
        </div>
      </div>
      <div className="collectionSearchContainer__search">
        <div className="collectionSearchContainer__search__input">
          <InputSearchComponent data={dataInput} onKeyDown={handleEnter} />
        </div>
        <div className="collectionSearchContainer__search__button">
          <ButtonSearchComponent filter={filter} />
        </div>
      </div>
    </div>
  );
};
